<div class="providers-toolbar">
  <app-business-partner-selector
    [defaultBusinessPartnerName]="selectedBusinessPartnerName()"
    (businessPartnerChange)="onBusinessPartnerChange($event)">
  </app-business-partner-selector>

  <button
    class="button primary"
    type="button"
    (click)="openAddDialog()"
    [disabled]="!hasSelectedBusinessPartner()"
    [title]="!hasSelectedBusinessPartner() ? ('bp_selector.select_business_partner' | translate) : ''">
    <span class="material-symbols-outlined">add</span>
    {{ 'providers.add_new_provider' | translate }}
  </button>
</div>

<ng-container *ngIf="!hasSelectedBusinessPartner(); else selectedBusinessPartnerTpl">
</ng-container>

<ng-template #selectedBusinessPartnerTpl>
  <ng-container *ngIf="loading(); else providersLoadedTpl">
    {{ 'providers.loading_providers' | translate }}
  </ng-container>
</ng-template>

<ng-template #providersLoadedTpl>
  <ng-container *ngIf="!error(); else providersErrorTpl">
    <ng-container *ngIf="(providers()?.length || 0) === 0; else providersGridTpl">
      <div class="empty">{{ 'providers.empty_state' | translate }}</div>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #providersGridTpl>
  <div class="providers-grid">
    <app-provider-card
      *ngFor="let provider of (providers() || [])"
      [provider]="provider"
      (editProvider)="openEditDialog($event)"
      (deleteProvider)="openDeleteDialog($event)">
    </app-provider-card>
  </div>
</ng-template>

<ng-template #providersErrorTpl>
  <div class="error">{{ error() }}</div>
</ng-template>

<app-provider-dialog
  *ngIf="showAddDialog()"
  [submitting]="submitting()"
  [providerTypes]="providerTypes()"
  [providerTypesLoading]="providerTypesLoading()"
  (closed)="closeAddDialog()"
  (submitProvider)="onSubmitAdd($event)">
</app-provider-dialog>

<app-provider-dialog
  *ngIf="editingProvider()"
  [submitting]="submitting()"
  [mode]="'edit'"
  [providerTypes]="providerTypes()"
  [providerTypesLoading]="providerTypesLoading()"
  [initialProvider]="editingProvider()"
  (closed)="closeEditDialog()"
  (submitProvider)="onSubmitEdit($event)">
</app-provider-dialog>

<app-delete-provider-dialog
  *ngIf="deletingProvider()"
  [provider]="deletingProvider()"
  [submitting]="submitting()"
  (closed)="closeDeleteDialog()"
  (confirmDelete)="onConfirmDelete()">
</app-delete-provider-dialog>
